// store/modal/modalSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    showRoles: false,
    showSkills: false,
    showNotification: false,
    showGoogleMap: false,
    showTemplates: false,
    showFeedback:false,
    showInfo:false
};

const modalSlice = createSlice({
    name: 'modal',
    initialState,
    reducers: {
        // Roles
        openRoles: (state) => {
            state.showRoles = true;
        },
        closeRoles: (state) => {

            state.showRoles = false;
        },
        toggleRoles: (state) => {
            state.showRoles = !state.showRoles;
        },
        // Skills
        openSkills: (state) => {
            state.showSkills = true;
        },
        closeSkills: (state) => {
            state.showSkills = false;
        },
        // Notification
        toggleNotification: (state) => {
            state.showNotification = !state.showNotification;
        },
        openNotification: (state) => {
            state.showNotification = true;
        },
        closeNotification: (state) => {
            state.showNotification = false;
        },
        openMaps: (state)=>{
            state.showGoogleMap =true
        },
        closeMaps: (state)=>{
           
            state.showGoogleMap=false
        },
        openTemplates: (state)=>{
            state.showTemplates = true;
        },
        closeTemplates: (state)=>{
            state.showTemplates = false;
        },
        //Feedback
        openFeedback: (state) => {
            state.showFeedback = true;
        },
        closeFeedback: (state) => {
            state.showFeedback = false;
        },
        //RecommendationInfo
        openInfo: (state) => {
            state.showInfo = true;
        },
        closeInfo: (state) => {
            state.showInfo = false;
        },
    },
});

export const { openRoles, closeRoles, toggleRoles, openSkills, closeSkills,toggleNotification, openNotification, closeNotification,openMaps, closeMaps, openTemplates, closeTemplates,
    openFeedback, closeFeedback, openInfo, closeInfo
 } = modalSlice.actions;

export default modalSlice.reducer;
